import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.addEventListener( 'DOMContentLoaded', () => {
  const historyWrappers = document.querySelectorAll( '.history-slider-wrapper' );
  
  if ( !historyWrappers.length ) {
    return;
  }

  // Initialize each history slider wrapper
  historyWrappers.forEach( ( historyWrapper ) => {
    const titlesSlider = historyWrapper.querySelector( '.history-slider-titles' );
    const contentsSlider = historyWrapper.querySelector( '.history-slider-contents' );
    
    if ( !titlesSlider || !contentsSlider ) {
      return;
    }

    // Parse configurations
    const titlesConfig = JSON.parse( titlesSlider.getAttribute( 'data-swiper' ) ) || {};
    const contentsConfig = JSON.parse( contentsSlider.getAttribute( 'data-swiper' ) ) || {};

    // Initialize sliders
    const titlesSwiper = new Swiper( titlesSlider, titlesConfig );
    const contentsSwiper = new Swiper( contentsSlider, contentsConfig );

    // Add click functionality to content slides
    const contentSlides = contentsSlider.querySelectorAll( '.swiper-slide' );
    
    contentSlides.forEach( ( slide, index ) => {
      slide.addEventListener( 'click', () => {
        // Slide to the clicked index in both sliders
        contentsSwiper.slideTo( index );
        titlesSwiper.slideTo( index );
      } );
    } );
  } );
} );